import { HTTP_METHODS } from "src/constants"
import { makeCall } from "src/helpers"
import { isRLTLang } from "src/i18n";
import { store } from "src/configureStore";
import _ from "lodash"
import rootRoutes from "src/routes"

const formatResponse = (items) => {
  const result = []
  const list =items.map((item) => ({
    label: isRLTLang() ? item.valueAr : item.valueFr,
    value: item.rank,
  }))
  result[0] = list.find(e=>e.value===1)
  result[1] = list.find(e=>e.value===2)
  result[2] = list.find(e=>e.value===5)
  result[3] = list.find(e=>e.value===4)
  result[4] = list.find(e=>e.value===3)
  return result
}

export const categoryUIHelper = (callback = f => f, param) => {
  const FETCH_ENDPOINT = "/sc/ms2/api/lists/2/options"
  const { token, headerTokenType, audience } = store.getState().common.auth || {}
  let tokenType = headerTokenType ? headerTokenType : 'Bearer'

  return new Promise((resolve, reject) =>
    makeCall(HTTP_METHODS.GET, FETCH_ENDPOINT, { _pagination: false }, {}
      // { Authorization: `${tokenType} ${token}`, audience: `${audience}` }
    )
      .then(resp => {
        let result = {}
        if (_.isPlainObject(resp.data)) {
          result = [resp.data]
        } else {
          result = resp.data
        }
        console.log("dddddddddddddd", formatResponse(result))
        resolve(callback(formatResponse(result)))
      })
      //.catch(err => reject(err.response))
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          window.location.href = rootRoutes.logout.path
          return
        }
        return reject(callback([]))
      })

  )
}


const formatOptions = (options) => {
  let values = {}
  options.forEach((option) => {
    values[option.rank] = isRLTLang() ? option.valueAr : option.valueFr
  })
  return values;
}


export const getCategoryUIHelper = (callback = f => f, param) => {
  const FETCH_ENDPOINT = "/sc/ms2/api/lists/2/options"
  const { token, headerTokenType, audience } = store.getState().common.auth || {}
  let tokenType = headerTokenType ? headerTokenType : 'Bearer'

  return new Promise((resolve, reject) =>
    makeCall(HTTP_METHODS.GET, FETCH_ENDPOINT, { _pagination: false }, {}
      // { Authorization: `${tokenType} ${token}`, audience: `${audience}` }
    )
      .then(resp => {
        let result = {}
        if (_.isPlainObject(resp.data)) {
          result = [resp.data]
        } else {
          result = resp.data
        }
        resolve(callback(formatOptions(result)))
      })
      //.catch(err => reject(err.response))
      .catch((err) => {
        if (err.response && err.response.status === 401) {
          window.location.href = rootRoutes.logout.path
          return
        }
        return reject(callback([]))
      })

  )
}